import React, { useCallback, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  LessonAnalytics_image,
  LessonAnalytics_massege_image,
  student_warning,
} from "../../../../../../assets/images/images";

import AOS from "aos";
import "aos/dist/aos.css";
import "./AssignmentAnalytics.css";
import { useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import api from "../../../../../../api/api";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import {
  convertSecondsToMinutes,
  timeDifferenceInMinutes,
  formatTime,
  addFormattedTime,
  escapeHtmlEntities,
} from "../../../../../../utils/utlis";
import QuestionNew from "../../../questions/Question_new";
import ShowTextPopup from "../course/ShowTextPopup";
import Helper from "../../../../../../utils/Helper";
import BackButton from "../../../../../../components/BackButton/BackButton";
import PreprocessAndRenderLatex from "../../../../../../components/ProcessRenderLatex";
import FilteredInput from "../../../../../../components/FilteredInput/FilteredInput";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Grid } from "@mui/material";
import { marked } from "marked";
import { getEditGrading, resetGrading } from "../../../../../../state/actions/editGradingAction";
import { processLatex } from "../../../../../../utils/PreProcessorLatexCode";
import { uploads_svg } from "../../../../../../assets/images/images";
import { Tooltip } from "react-tooltip";
import { headphones } from "../../../../../../assets/images/images"
import { normalizeLatexToDoubleDollar } from "./NewLessons/utils/fileHelpers";
import { getAllCourseListByTeacher } from "../../../../../../state/actions/getAllCourseListByTeacherAction";
import { updateGlobalState } from "../../../../../../state/global/slice";

const AssignmentAnalytics = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state.globalState);
  const teacher_id = globalState?.teacher_details?.data?.teacher_id;
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  let { course_id, assignment_id, analytic_id } = useParams();
  const [showDropdown, setShowDropdown] = useState(false); // State to control visibility
  const toggleDropdown = (index, array) => {
    setShowDropdown(!showDropdown); // Toggle the visibility state
    const course_list = globalState.course_list?.filter(
      (course) => course.course_id !== Number(course_id),
    );
    updateState("course_list", course_list);
    dispatch(getAllCourseListByTeacher(teacher_id, token));
    setAssignmentIndex(index);
    setArrayIndex(array);
  };

  const student_id = location.state?.student?.student_id ?? analytic_id;
  const assignmentId = location.state?.student?.assignment_id ?? assignment_id;
  const selectedAssignment = location.state?.selectedAssignment;
  const is_practice_assignment = location?.state?.student?.is_practice_assignment
  const practice_assignment_id = location?.state?.student?.practice_assignment_id


  const { token } = useAuth();
  const { role } = useSelector((state) => state.globalState);
  const [analyticHeadData, setAnalyticHeadData] = useState([]);
  const [maxTimeTakenMinutes, setmaxTimeTakenMinutes] = useState(0);
  const [maxTimeTakenSeconds, setmaxTimeTakenSeconds] = useState(0);
  const [
    assignmentcompletedDuration,
    setAssignmentcompletedDuration,
  ] = useState("");
  const [totalTimeTaken, settotalTimeTaken] = useState("");
  const [analyticDetailsData, setAnalyticDetailsData] = useState({});
  const [headerData, setheaderData] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const [errorData, setErrorData] = useState({
    error: false,
    errormsg: "",
  });




  const allCourses = useSelector(
    (state) => state?.getAllCourseListByTeacher?.courses,
  );

  const TeacherMyCourse = allCourses?.some(
    (course) => Number(course?.course_id) === Number(course_id),
  );




  const courseType = location?.state?.courseType


  const getAssignmentAnalytics = async () => {
    setisLoading(true);

    // const apiEndpoint = is_practice_assignment
    // ? `/assignments/get-practice-assignment-submission/?student_id=${student_id}&practice_assignment_id=${practice_assignment_id}`
    // : `/assignments/submissions/?student_id=${student_id}&assignment_id=${assignmentId}`;

    let apiEndpoint = "";

    if (courseType === 1) {
      // Regular course
      apiEndpoint = is_practice_assignment
        ? `/assignments/get-practice-assignment-submission/?student_id=${student_id}&practice_assignment_id=${practice_assignment_id}`
        : `/assignments/submissions/?student_id=${student_id}&assignment_id=${assignmentId}`;
    } else {
      // Competitive course
      apiEndpoint = is_practice_assignment
        ? `/competitive/assignments/get-practice-assignment-submission/?student_id=${student_id}&practice_assignment_id=${practice_assignment_id}`
        : `/competitive/assignments/submissions/?student_id=${student_id}&assignment_id=${assignmentId}`;
    }

    api
      .get(
        apiEndpoint,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          setisLoading(false);
          if (response.data?.data) {
            setAnalyticDetailsData(response.data?.data);
            setAnalyticHeadData(response.data?.data?.assignment_analytics);
            const completedAssignment = response.data?.data?.assignment_analytics.find(
              (item) => item.status === "Completed"
            );
            if (completedAssignment) {
              setheaderData(completedAssignment);
            } else {
              // Optionally handle the case where there are no completed assignments
            }
            if (
              response.data?.data?.student_answers_json &&
              response.data?.data?.student_answers_json.length > 0
            ) {
              const timeTakenArray = response.data?.data?.student_answers_json.map(
                (question) => question.time_taken
              );

              setAssignmentcompletedDuration(
                timeTakenArray[timeTakenArray.length - 1]
              ); // Get the last element
            }
            if (
              response.data?.data?.student_answers_json &&
              response.data?.data?.student_answers_json.length > 0
            ) {
              const studentAnswers = response.data.data.student_answers_json;
              const lastTimeTaken = studentAnswers[studentAnswers.length - 1].time_taken;

              if (lastTimeTaken === "0" || lastTimeTaken === 0 || !lastTimeTaken) {
                settotalTimeTaken(completedAssignment?.assignment_duration * 60);

              } else {
                // Sum all time_taken (use 1 if any time_taken is 0 or falsy)
                const total = studentAnswers.reduce((sum, item) => {
                  return (
                    sum +
                    (item.time_taken === "0" || item.time_taken === 0 || !item.time_taken
                      ? 1
                      : item.time_taken)
                  );
                }, 0);

                settotalTimeTaken(total);
              }

              // const timeTakenArray = response.data?.data?.student_answers_json.reduce(
              //   (sum, item) => {
              //     // Add either the time taken or 1 if the time taken is 0
              //     return (
              //       sum +
              //       (item.time_taken === "0" ||
              //         item.time_taken === 0 ||
              //         !item.time_taken
              //         ? 1
              //         : item.time_taken)
              //     );
              //   },
              //   0
              // );
              // settotalTimeTaken(timeTakenArray); // Get the last element
            }
            const timeTakenValues = analyticDetailsData?.student_answers_json.map(
              (question) => question.time_taken
            );
            const maxTimeTaken = Math.max(...timeTakenValues);
            setmaxTimeTakenMinutes(
              maxTimeTaken > 0 ? Math.floor(maxTimeTaken / 60) : 0
            );
            setmaxTimeTakenSeconds(maxTimeTaken > 0 ? maxTimeTaken % 60 : 0);
          } else {
            setErrorData({
              error: true,
              errormsg: response.data?.message ?? "No Record Found",
            });
          }
        } else {
          setErrorData({
            error: true,
            errormsg: response.data?.message ?? "Something went wrong",
          });
        }
      })
      .catch((error) => {
        setisLoading(false);
        setErrorData({
          error: true,
          errormsg: error,
        });
      });
  };
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    localStorage.setItem(
      "assignmentanalyticsdetails",
      JSON.stringify(selectedAssignment)
    );
    getAssignmentAnalytics();
    if (analyticDetailsData.length > 0) {
      getRubric(analyticDetailsData?.rubric);
    }
    AOS.init({
      duration: 500,
    });
  }, [student_id, assignmentId]);

  //
  const [rubricData, setRubric] = useState(null);
  const [showRubric, setShowRubric] = useState(false);
  const toogle = (question) => {
    setShowRubric((p) => !p);
  };


  const getRubric = async (rubric_id) => {
    await api
      .get(`assignments/get-rubric/${rubric_id}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setRubric(response?.data?.data);
        } else {
          setRubric({
            rubric: null,
            lesson: null,
          });
        }
      })
      .catch((error) => {
        setRubric({
          rubric: null,
          lesson: null,
        });
      });
  };

  const [showdownlodefile, setShowdownlodefile] = useState(false); // State to control visibility
  const [fileNameError, setFileNameError] = useState("");
  const [fileNameDownload, setFileNameDownload] = useState("");
  const toggledownlodefile = () => {
    setFileNameDownload("");
    setFileNameError("");
    setShowdownlodefile(!showdownlodefile); // Toggle the visibility state
  };
  const handleFileNameChange = useCallback((e) => {
    const enteredValue = e.target.value.trim();
    setFileNameDownload(e.target.value);
    if (!enteredValue) {
      setFileNameError("Please enter filename");
    } else {
      setFileNameError("");
    }
  }, []);

  const inputRefDownload = useRef(null);
  useEffect(() => {
    if (inputRefDownload.current) {
      inputRefDownload.current.focus();
    }
  }, [fileNameDownload]);


  const AssignmentHeader = () => {
    // Security: migrated from `xlsx` (had unfixable HIGH CVEs) to `exceljs`.
    // Function is now async because `exceljs.workbook.xlsx.writeBuffer()` is async.
    // Layout preserved exactly: header rows 1-6, blank row 7, JSON headers at row 8, data at rows 9+.
    const exportToExcel = async () => {
      if (fileNameDownload === null || fileNameDownload === "") {
        setFileNameError("Please enter filename");
        return; // Ensure function exits here if there's no file name
      }

      if (analyticHeadData.length === 0 || !location.state) {
        console.error("Data is missing, cannot generate Excel file.");
        return;
      }

      const headerInfo = {
        "Assignment Name": analyticHeadData[0]?.assignment_name || "",
        "Student Name": analyticHeadData[0]?.student_name || "",
        "Assignment Score": location.state?.score || "",
        "Assignment Started At":
          Helper.formatDateTimeToLocal(location.state.started_date).time +
          " " +
          Helper.formatDateTimeToLocal(location.state.started_date).date,
        "Assignment Ended At":
          Helper.formatDateTimeToLocal(location.state.completed_date).time +
          " " +
          Helper.formatDateTimeToLocal(location.state.completed_date).date,
        "Time Duration":
          timeDifferenceInMinutes(
            analyticHeadData[0]?.completed_date,
            analyticHeadData[0]?.started_date
          ) || "",
      };

      const headerRows = [
        ["Assignment Name", headerInfo["Assignment Name"]],
        ["Student Name", headerInfo["Student Name"]],
        ["Assignment Score", headerInfo["Assignment Score"]],
        ["Assignment Started At", headerInfo["Assignment Started At"]],
        ["Assignment Ended At", headerInfo["Assignment Ended At"]],
        ["Time Duration", headerInfo["Time Duration"]],
      ];

      if (
        !analyticDetailsData?.student_answers_json ||
        !Array.isArray(analyticDetailsData.student_answers_json)
      ) {
        console.error("Invalid or missing student_answers_json data.");
        return;
      }

      const transformedData = analyticDetailsData.student_answers_json.map(
        (item, index, array) => ({
          "Sr No": index + 1,
          Question: item.question,
          "Submitted Answer": item.student_answer,
          "Correct Answer": item.ai_answer,
          "Time Taken":
            index > 0
              ? convertSecondsToMinutes(
                array[index - 1]
                  ? item.time_taken - array[index - 1].time_taken
                  : ""
              )
              : convertSecondsToMinutes(item.time_taken),
          "Answer Status":
            analyticDetailsData?.ai_evaluation_json?.questions[index]
              ?.evaluation,
          "Uploads": "Uploads"
        })
      );

      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("AssignmentAnalytics");

        // Rows 1-6: header info (key/value pairs)
        headerRows.forEach((row) => worksheet.addRow(row));

        // Row 7: empty (mirrors the previous `origin: "A8"` offset behavior)
        worksheet.addRow([]);

        // Row 8: column headers (from JSON keys), rows 9+: values
        if (transformedData.length > 0) {
          const columnHeaders = Object.keys(transformedData[0]);
          worksheet.addRow(columnHeaders);
          transformedData.forEach((item) => {
            worksheet.addRow(Object.values(item));
          });
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileNameDownload + ".xlsx");
      } catch (error) {
        console.error("Error writing Excel file:", error);
      }
    };

    const onStudentViewProfile = () => {
      const student_id = location.state?.student_id || location.state?.student_id == undefined ? location.state?.student?.student_id : location.state?.student_id;
      navigate(`/student/${student_id}`);
    };

    return (
      <>
        {/* <div className="view-course-Details-back-btn-folder">
          <BackButton buttonName={"Assignment Analytics"} />
        </div> */}
        <div className="mobile-analytics-header mobile-cards-wrapper"
          style={{ boxShadow: '0px 0px 8px 0px #0000001F', borderRadius: '12px', padding: '20px', marginBottom: '16px' }}
        >
          {/* Profile */}
          <div className="flex flex-col items-center gap-1 mb-4">
            <img
              src={analyticHeadData.length > 0 && (analyticHeadData[0]?.student_profile_pic || LessonAnalytics_image)}
              alt=""
              className="w-20 h-20 rounded-full object-cover"
            />
            <h2 className="text-[16px] font-medium text-[#000] m-0">
              {analyticHeadData.length > 0 && analyticHeadData[0]?.student_name}
            </h2>
            {role === "Teacher" && (
              <a href="#" className="text-[#0068ff] text-[13px]"
                onClick={(e) => { e.preventDefault(); onStudentViewProfile(); }}
              >
                View Profile
              </a>
            )}
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 items-center gap-3 text-left">
            <div>
              <p className="text-[12px] text-[#888] m-0">Score</p>
              <p className="text-[16px] font-medium text-[#000] m-0">
                {analyticDetailsData.marks_awarded} / {analyticDetailsData.total_marks}
              </p>
            </div>
            <div>
              <p className="text-[12px] text-[#888] m-0">Assignment Created Date</p>
              <p className="text-[15px] font-medium text-[#000] m-0">{Helper.formatDateTimeToLocal(headerData?.created_at).date}</p>
            </div>
            {analyticHeadData.length > 0 && (
              <div>
                <p className="text-[12px] text-[#888] m-0">Student Started On</p>
                <p className="text-[15px] font-medium text-[#000] m-0">{Helper.formatDateTimeToLocal(headerData?.started_date).date}</p>
                <p className="text-[13px] text-[#666] m-0">{Helper.formatDateTimeToLocal(headerData?.started_date).time}</p>
              </div>
            )}
            {analyticHeadData.length > 0 && (
              <div>
                <p className="text-[12px] text-[#888] m-0">Student Submitted On</p>
                <p className="text-[15px] font-medium text-[#000] m-0">{Helper.formatDateTimeToLocal(headerData?.completed_date).date}</p>
                <p className="text-[13px] text-[#666] m-0">{Helper.formatDateTimeToLocal(headerData?.completed_date).time}</p>
              </div>
            )}
            {!is_practice_assignment && (
              <div>
                <p className="text-[12px] text-[#888] m-0">Time Allotted</p>
                <p className="text-[15px] font-medium text-[#000] m-0">{formatTime(headerData?.assignment_duration * 60)}</p>
              </div>
            )}
            <div>
              <p className="text-[12px] text-[#888] m-0">Time Taken</p>
              <p className="text-[15px] font-medium m-0"
                style={{ color: headerData?.assignment_duration * 60 < totalTimeTaken && !is_practice_assignment ? "red" : "#000" }}
              >
                {formatTime(totalTimeTaken)}
              </p>
              {!is_practice_assignment && headerData?.assignment_duration * 60 < totalTimeTaken && (
                <p className="text-[12px] m-0" style={{ color: 'red' }}>Delayed Submission</p>
              )}
            </div>
          </div>
        </div>
        <div className="LessonAnalytics-profile-container desktop-analytics-header">
          <div className="LessonAnalytics-profile">
            <div className="LessonAnalytics-profile-image">
              <img
                src={
                  analyticHeadData.length > 0 &&
                  (analyticHeadData[0]?.student_profile_pic ||
                    LessonAnalytics_image)
                }
                alt=""
              />
            </div>
            <h2>
              {analyticHeadData.length > 0 && analyticHeadData[0]?.student_name}
            </h2>
            {(role === "Teacher" || role === "Admin") && (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault(); // This prevents the default anchor link behavior
                  onStudentViewProfile();
                }}
              >
                View Profile
              </a>
            )}
          </div>
          <div className="LessonAnalytics-profile-folder">
            <p>Score</p>
            <h2>
              {analyticDetailsData.marks_awarded} /{" "}
              {analyticDetailsData.total_marks}
            </h2>
          </div>
          <div className="LessonAnalytics-profile-folder">
            <p>Assignment</p>
            <p>Created Date</p>
            <>
              <h2>{Helper.formatDateTimeToLocal(headerData?.created_at).date}</h2>
            </>
          </div>
          {headerData?.assignment_end_date && (
            <div className="LessonAnalytics-profile-folder">
              <p>Assignment</p>
              <p>End Date</p>
              <>
                <h2>
                  {Helper.formatDateTimeToLocal(headerData?.assignment_end_date).date}
                </h2>
              </>
            </div>
          )}

          {analyticHeadData.length > 0 && (
            <div className="LessonAnalytics-profile-folder">
              <p>Student</p>
              <p>Started On</p>
              <>
                <h2>{Helper.formatDateTimeToLocal(headerData?.started_date).date}</h2>
                <span className="lessonanalystics-date">
                  {Helper.formatDateTimeToLocal(headerData?.started_date).time}
                </span>
              </>
            </div>
          )}
          {analyticHeadData.length > 0 && (
            <div className="LessonAnalytics-profile-folder">
              <p>Student</p>
              <p>Submitted On</p>
              <>
                <h2>
                  {Helper.formatDateTimeToLocal(headerData?.completed_date).date}
                </h2>
                <span className="lessonanalystics-date">
                  {Helper.formatDateTimeToLocal(headerData?.completed_date).time}
                </span>
              </>
            </div>
          )}
          {!is_practice_assignment && <div className="LessonAnalytics-profile-folder">
            <p>Time Allotted</p>
            <h2>{formatTime(headerData?.assignment_duration * 60)}</h2>
          </div>}
          <div className="LessonAnalytics-profile-folder">
            <p>Time Taken</p>
            <h2
              style={{
                color:
                  headerData?.assignment_duration * 60 < totalTimeTaken && !is_practice_assignment
                    ? "red"
                    : "",
              }}
            >
              {formatTime(totalTimeTaken)}
            </h2>
            {!is_practice_assignment && <span
              style={{
                color:
                  headerData?.assignment_duration * 60 < totalTimeTaken
                    ? "red"
                    : "",
              }}
              className="lessonanalystics-date"
            >
              {" "}
              {headerData?.assignment_duration * 60 < totalTimeTaken
                ? "Delayed Submission"
                : ""}
            </span>}
          </div>
        </div>

        {showdownlodefile && (
          <div className="Download-File-popup-wrappper">
            <div className="Download-File-popup-container">
              <div className="download-popup">
                <h2>Download File as</h2>
                <button className="close-btn" onClick={toggledownlodefile}>
                  ×
                </button>
                <div className="input-section">
                  <label>
                    File Name *{" "}
                    <input
                      ref={inputRefDownload}
                      type="text"
                      name="namefiletodnld"
                      placeholder="Enter File Name"
                      value={fileNameDownload}
                      onChange={handleFileNameChange}
                    />
                    {fileNameError && (
                      <p style={{ color: "red" }}>{fileNameError}</p>
                    )}
                  </label>
                </div>
                <div className="button-section">
                  <button className="spreadsheet-btn" onClick={exportToExcel}>
                    Spreadsheet (.xlsx)
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const [assignmentIndex, setAssignmentIndex] = useState(0);
  const [arrayIndex, setArrayIndex] = useState(0);



  // Helper to determine if assignment type is MCQ or True/False
  const isAutoGradedType = (type) => ["MCQ", "True/False", "TF"].includes(type);

  // Helper to calculate score for auto-graded types
  const getAutoGradedScore = (studentAnswer, correctOption, totalMarks) => {
    return (correctOption === null) ? null : (studentAnswer === correctOption) ? totalMarks : 0
  };

  // Helper to update evaluation for auto-graded types
  const updateAutoGradedEvaluation = (updatedData, assignmentIndex, option) => {
    const question = updatedData.student_answers_json[assignmentIndex];
    const evalQuestion = updatedData.ai_evaluation_json.questions[assignmentIndex];
    const isCorrect = question.student_answer === option;
    if (isCorrect) {
      if (evalQuestion.evaluation !== 'Correct') {
        updatedData.marks_awarded += evalQuestion.marks;
      }
      evalQuestion.marks_obtained = evalQuestion.marks;
      evalQuestion.evaluation = "Correct";
    } else {
      if (evalQuestion.evaluation !== 'Incorrect') {
        updatedData.marks_awarded -= evalQuestion.marks;
      }
      evalQuestion.marks_obtained = 0;
      evalQuestion.evaluation = "Incorrect";
    }
  };

  // Helper to update evaluation for manually graded types
  const updateManualGradedEvaluation = (updatedData, assignmentIndex, getTeacherScore) => {
    const evalQuestion = updatedData.ai_evaluation_json.questions[assignmentIndex];
    const marksDiff = getTeacherScore - evalQuestion.marks_obtained;
    if (marksDiff < 0) {
      updatedData.marks_awarded -= Math.abs(marksDiff);
    } else {
      updatedData.marks_awarded += marksDiff;
    }
    if (getTeacherScore == 0) {
      evalQuestion.evaluation = 'Incorrect';
    } else if (getTeacherScore == evalQuestion.marks) {
      evalQuestion.evaluation = 'Correct';
    } else {
      evalQuestion.evaluation = 'Partial Credit';
    }
    evalQuestion.marks_obtained = getTeacherScore;
  };

  const handleGetTeacherAnswerAssignmentAnalytics = (option, feedbackText, assignmentType, getTeacherScore, saveStatues) => {
    // Prepare data for dispatch


    const question = analyticDetailsData?.student_answers_json[assignmentIndex];
    const evalQuestion = analyticDetailsData?.ai_evaluation_json?.questions[assignmentIndex];
    const score = getTeacherScore
      ? getTeacherScore
      : isAutoGradedType(assignmentType)
        ? getAutoGradedScore(question.student_answer, option, evalQuestion.marks)
        : null;

    const data = {
      submission_id: analyticDetailsData?.submission_id,
      assignment_id: analyticDetailsData?.assignment,
      question_id: question?.question_id,
      score,
      ai_feedback: feedbackText ? (feedbackText !== evalQuestion?.ai_feedback) ? feedbackText.replace(/\s+/g, ' ').trim() : null : null,
      student_id: analyticDetailsData?.student,
      ai_answer: option || evalQuestion?.ai_answer || "",
      update_all: saveStatues === 'Save-For-Student' ? false : true
    };

    dispatch(getEditGrading(data, token));

    setAnalyticDetailsData((prevData) => {
      const updatedData = { ...prevData };
      // Update ai_answer if provided
      if (option) {
        updatedData.student_answers_json[assignmentIndex].ai_answer = option;
      }
      // Update ai_feedback if provided
      if (feedbackText) {
        updatedData.ai_evaluation_json.questions[assignmentIndex].ai_feedback = feedbackText;
      }
      // Update evaluation and marks
      if (isAutoGradedType(assignmentType)) {
        updateAutoGradedEvaluation(updatedData, assignmentIndex, option);
      } else if (getTeacherScore) {
        updateManualGradedEvaluation(updatedData, assignmentIndex, getTeacherScore);
      }
      return updatedData;
    });
  };






  const PHRASE_TRANSLATIONS = {
    "en": {
      "Correct": "Correct",
      "Incorrect": "Incorrect",
      "Partial Credit": "Partially correct"
    },
    "es": {
      "Correct": "Correcto",
      "Incorrect": "Incorrecto",
      "Partial Credit": "Parcialmente correcto"
    },
    "fr": {
      "Correct": "Correct",
      "Incorrect": "Incorrect",
      "Partial Credit": "Partiellement correct"
    },
    "de": {
      "Correct": "Richtig",
      "Incorrect": "Falsch",
      "Partial Credit": "Teilweise richtig"
    },
    "it": {
      "Correct": "Corretto",
      "Incorrect": "Sbagliato",
      "Partial Credit": "Parzialmente corretto"
    },
    "pt": {
      "Correct": "Correto",
      "Incorrect": "Incorreto",
      "Partial Credit": "Parcialmente correto"
    },
    "ru": {
      "Correct": "Верно",
      "Incorrect": "Неверно",
      "Partial Credit": "Частично верно"
    },
    "zh": {
      "Correct": "正确",
      "Incorrect": "错误",
      "Partial Credit": "部分正确"
    },
    "ja": {
      "Correct": "正解",
      "Incorrect": "不正解",
      "Partial Credit": "部分正解"
    },
    "ko": {
      "Correct": "정확함",
      "Incorrect": "부정확함",
      "Partial Credit": "부분 정확함"
    },
    "ar": {
      "Correct": "صحيح",
      "Incorrect": "غير صحيح",
      "Partial Credit": "جزء صحيح"
    },
    "hi": {
      "Correct": "सही",
      "Incorrect": "गलत",
      "Partial Credit": "आंशिक रूप से सही"
    },
    "bn": {
      "Correct": "সঠিক",
      "Incorrect": "ভুল",
      "Partial Credit": "আংশিকভাবে সঠিক"
    },
    "tr": {
      "Correct": "Doğru",
      "Incorrect": "Yanlış",
      "Partial Credit": "Kısmen doğru"
    },
    "nl": {
      "Correct": "Juist",
      "Incorrect": "Onjuist",
      "Partial Credit": "Deels juist"
    },
    "pl": {
      "Correct": "Poprawne",
      "Incorrect": "Niepoprawne",
      "Partial Credit": "Częściowo poprawne"
    },
    "vi": {
      "Correct": "Chính xác",
      "Incorrect": "Không chính xác",
      "Partial Credit": "Một phần chính xác"
    },
    "th": {
      "Correct": "ถูกต้อง",
      "Incorrect": "ไม่ถูกต้อง",
      "Partial Credit": "ถูกต้องบางส่วน"
    },
    "ur": {
      "Correct": "درست",
      "Incorrect": "غلط",
      "Partial Credit": "جزوی طور پر درست"
    },
    "sv": {
      "Correct": "Korrekt",
      "Incorrect": "Felaktigt",
      "Partial Credit": "Delvis korrekt"
    },
    "id": {
      "Correct": "Benar",
      "Incorrect": "Salah",
      "Partial Credit": "Sebagian benar"
    },
    "fi": {
      "Correct": "Oikein",
      "Incorrect": "Väärin",
      "Partial Credit": "Osittain oikein"
    },
    "uk": {
      "Correct": "Правильно",
      "Incorrect": "Неправильно",
      "Partial Credit": "Частково правильно"
    },
    "el": {
      "Correct": "Σωστό",
      "Incorrect": "Λάθος",
      "Partial Credit": "Μερικώς σωστό"
    },
    "cs": {
      "Correct": "Správně",
      "Incorrect": "Nesprávně",
      "Partial Credit": "Částečně správně"
    },
    "he": {
      "Correct": "נכון",
      "Incorrect": "שגוי",
      "Partial Credit": "חלקית נכון"
    },
    "ro": {
      "Correct": "Corect",
      "Incorrect": "Incorect",
      "Partial Credit": "Parțial corect"
    },
    "hu": {
      "Correct": "Helyes",
      "Incorrect": "Helytelen",
      "Partial Credit": "Részben helyes"
    },
    "da": {
      "Correct": "Korrekt",
      "Incorrect": "Forkert",
      "Partial Credit": "Delvist korrekt"
    },
    "no": {
      "Correct": "Riktig",
      "Incorrect": "Feil",
      "Partial Credit": "Delvis riktig"
    },
    "sk": {
      "Correct": "Správne",
      "Incorrect": "Nesprávne",
      "Partial Credit": "Čiastočne správne"
    },
    "ms": {
      "Correct": "Betul",
      "Incorrect": "Salah",
      "Partial Credit": "Sebahagian betul"
    },
    "la": {
      "Correct": "Rectum",
      "Incorrect": "Incorrectum",
      "Partial Credit": "Partim rectum"
    }
  }

  // const AssignmentAnalytics = ({ analyticDetailsData }) => {}
  const language = analyticDetailsData?.assignment_analytics?.language || "en";

  // Function to get the translation based on language
  const getTranslation = (key) => {
    return PHRASE_TRANSLATIONS[language]?.[key] || key;
  };

  const uploads = [
    { id: 1, numberOffiles: 2 },
    { id: 2, numberOffiles: 1 },
    { id: 3, numberOffiles: 4 },
  ]

  useEffect(() => {
    return () => {
      dispatch(resetGrading());
      getAllCourseListByTeacher(
        teacher_id,
        token,
      )
    }
  }, [])

  return (
    <>

      <div id="LessonAnalytics-section">
        <div className="LessonAnalytics-wrapper assignment-analytics-page">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="view-course-Details-back-btn-folder">
                  <BackButton buttonName={"Assignment Analytics"} />
                </div>
                {isLoading ? (
                  <div >
                    <Grid
                      height={"50vh"}
                      xs={12}
                      container
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <CircularProgress size={80} />
                    </Grid>
                  </div>
                ) : <>
                  <AssignmentHeader />
                  <div className="LessonViewProgress-table-container AssignmentAnalytics-table-container">
                    <div className="mobile-cards-wrapper">
                      {analyticDetailsData?.student_answers_json?.map((question, index, array) => (
                        <div key={index} className="mobile-student-card" style={{ boxShadow: '0px 0px 8px 0px #0000001F' }}>

                          {/* Question */}
                          <div className="text-left">
                            <p className="text-[12px] text-[#888] font-medium m-0">Question</p>
                            <p className="text-[13px] text-[#000] m-0">
                              {`${index + 1}. `}
                              <PreprocessAndRenderLatex
                                content={normalizeLatexToDoubleDollar(question.question || " ")}
                                latexInline={true}
                              />
                            </p>
                          </div>

                          {/* Submitted Answer */}
                          <div className="text-left">
                            <p className="text-[12px] text-[#888] font-medium m-0">Submitted Answer</p>
                            <p className="text-[13px] text-[#000] m-0">
                              {(() => {
                                const files = analyticDetailsData?.student_answers_json?.[index]?.file_data || [];
                                const hasAudio = files.some(file => {
                                  const filename = (typeof file === "string" && file) || file?.name || file?.file_path || file?.file_name || file?.url || "";
                                  return filename.toLowerCase().endsWith(".webm");
                                });
                                return hasAudio ? "Answer submitted via recording" : question.student_answer || "Answer submitted via document";
                              })()}
                            </p>
                          </div>

                          {/* Time Duration + Answer Status */}
                          <div className="flex justify-between items-center">
                            <div className="text-left">
                              <p className="text-[12px] text-[#888] font-medium m-0">Time Duration</p>
                              <p className="text-[13px] text-[#000] m-0">{convertSecondsToMinutes(question.time_taken)}</p>
                            </div>
                            <div className="text-left">
                              <p className="text-[12px] text-[#888] font-medium m-0">Answer Status</p>
                              <div className="LessonViewProgress-student-status AssignmentAnalytics-answer-status"
                                style={{
                                  color: analyticDetailsData?.ai_evaluation_json?.questions[index]?.evaluation === "Correct" ? "#28991f"
                                    : analyticDetailsData?.ai_evaluation_json?.questions[index]?.evaluation === "Incorrect" ? "#b24747" : "#FFA800",
                                  backgroundColor: analyticDetailsData?.ai_evaluation_json?.questions[index]?.evaluation === "Correct" ? "#e6ffe5"
                                    : analyticDetailsData?.ai_evaluation_json?.questions[index]?.evaluation === "Incorrect" ? "#ffd6d6" : "#FFE5CC",
                                }}
                              >
                                <span>
                                  {getTranslation(analyticDetailsData?.ai_evaluation_json?.questions[index]?.evaluation)}
                                  <i className={`fa-solid ${analyticDetailsData?.ai_evaluation_json?.questions[index]?.evaluation === "Correct" ? "fa-check"
                                    : analyticDetailsData?.ai_evaluation_json?.questions[index]?.evaluation === "Incorrect" ? "fa-x" : "fa-check"}`}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* View Assessment + Uploads */}
                          <div className="flex justify-between items-center">
                            <a href="#" className="text-[#0068ff] text-[13px] underline"
                              onClick={(e) => { e.preventDefault(); toggleDropdown(index, array); }}
                            >
                              View Assessment
                            </a>

                            {analyticDetailsData?.student_answers_json?.[index]?.file_data?.length > 0 ? (() => {
                              const files = analyticDetailsData?.student_answers_json?.[index]?.file_data;
                              const hasOnlyWebmAudio = files?.length === 1 && files[0]?.name?.toLowerCase().endsWith('.webm');
                              return (
                                <div className="uploads-section">
                                  <img src={hasOnlyWebmAudio ? headphones : uploads_svg} alt="" style={{ opacity: 0.6 }} />
                                  <div className="uploads-files">
                                    {files.length} {hasOnlyWebmAudio ? files.length === 1 ? "Audio file" : "Audio files" : files.length === 1 ? "File" : "Files"}
                                  </div>
                                </div>
                              );
                            })() : <div className="no-uploads-dash">-</div>}
                          </div>
                        </div>
                      ))}
                    </div>
                    <table className="desktop-table">
                      <thead>
                        <tr>
                          <th style={{ width: "5%", textAlign: "center" }}>
                            Sr no.
                          </th>
                          <th>Question</th>
                          <th style={{ textAlign: "center" }}>
                            Submitted Answer
                          </th>
                          <th>Time Taken</th>
                          <th>Answer Status</th>
                          <th>View Assignment</th>
                          <th>Uploads</th>
                        </tr>
                      </thead>

                      {/* {isLoading ? (
                      <div style={{ display: "table-caption" }}>
                        <Grid
                          height={"50vh"}
                          xs={12}
                          container
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <CircularProgress size={80} />
                        </Grid>
                      </div>
                    ) : <></>} */}
                      {analyticDetailsData?.student_answers_json?.length >
                        0 ? (
                        <tbody>
                          {analyticDetailsData?.student_answers_json?.map(
                            (question, index, array) => (
                              <tr key={index}>
                                <td style={{ width: "5%", textAlign: "center" }}>
                                  {index + 1}{" "}
                                  <Tooltip style={{ width: "600px" }} id={`tooltip-question-${index}`} place="bottom">
                                    <PreprocessAndRenderLatex
                                      content={normalizeLatexToDoubleDollar(question.question || " ")}
                                      latexInline={true}
                                    />
                                  </Tooltip>
                                </td>
                                <td style={{ width: "30%" }} >
                                  <span style={{ display: "flex" }} data-tooltip-id={`tooltip-question-${index}`}>
                                    <PreprocessAndRenderLatex
                                      // content={processLatex(marked(question.question || `" "`))}
                                      // content={question.question || `" "`}
                                      content={normalizeLatexToDoubleDollar(question.question || " ")}
                                      wrapperStyle={{
                                        width: "250px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      title={question.question}
                                      latexInline={true}
                                    />

                                  </span>
                                </td>
                                <td style={{ width: "14%", textAlign: "center" }}>
                                  <span style={{ width: "93%", display: "flex" }}>
                                    <ul className="Submitted-Answer-list">
                                      <li>
                                        {(() => {
                                          const files =
                                            analyticDetailsData?.student_answers_json?.[index]?.file_data || [];

                                          // Check if ANY file is .webm audio
                                          const hasAudio = files.some(file => {
                                            const filename =
                                              (typeof file === "string" && file) ||
                                              file?.name ||
                                              file?.file_path ||
                                              file?.file_name ||
                                              file?.url ||
                                              "";
                                            return filename.toLowerCase().endsWith(".webm");
                                          });

                                          const displayText = hasAudio
                                            ? "Answer submitted via recording"
                                            : question.student_answer || "Answer submitted via document";

                                          return (
                                            <PreprocessAndRenderLatex
                                              // content={processLatex(marked(displayText))}
                                              // content={displayText}
                                              content={normalizeLatexToDoubleDollar(displayText)}
                                              wrapperStyle={{
                                                width: "250px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              }}
                                              latexInline={true}
                                            />
                                          );
                                        })()}
                                      </li>
                                    </ul>
                                  </span>
                                </td>
                                <td style={{ width: "14%" }}>
                                  <div className="hover-wrapper">
                                    <div className="completedat-time">
                                      {convertSecondsToMinutes(
                                        question.time_taken
                                      )}
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "14%" }}>
                                  <div
                                    className={`LessonViewProgress-student-status AssignmentAnalytics-answer-status `}
                                    style={{
                                      color:
                                        analyticDetailsData?.ai_evaluation_json
                                          ?.questions[index]?.evaluation ===
                                          "Correct"
                                          ? "#28991f"
                                          : analyticDetailsData
                                            ?.ai_evaluation_json?.questions[
                                            index
                                          ]?.evaluation === "Incorrect"
                                            ? "#b24747"
                                            : "#FFA800",
                                      backgroundColor:
                                        analyticDetailsData?.ai_evaluation_json
                                          ?.questions[index]?.evaluation ===
                                          "Correct"
                                          ? "#e6ffe5"
                                          : analyticDetailsData
                                            ?.ai_evaluation_json?.questions[
                                            index
                                          ]?.evaluation === "Incorrect"
                                            ? "#ffd6d6"
                                            : "#FFE5CC",
                                    }}
                                  >
                                    <span>
                                      {/* {
                                      analyticDetailsData?.ai_evaluation_json
                                        ?.questions[index]?.evaluation
                                    } */}

                                      {getTranslation(analyticDetailsData?.ai_evaluation_json?.questions[index]?.evaluation)}

                                      <i
                                        className={`fa-solid ${analyticDetailsData?.ai_evaluation_json
                                          ?.questions[index]?.evaluation ===
                                          "Correct"
                                          ? "fa-check"
                                          : analyticDetailsData
                                            ?.ai_evaluation_json?.questions[
                                            index
                                          ]?.evaluation === "Incorrect"
                                            ? "fa-x"
                                            : "fa-check"
                                          }`}
                                      />
                                    </span>
                                  </div>
                                </td>
                                <td style={{ width: "14%" }}>
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      toggleDropdown(index, array);
                                    }}
                                  >
                                    View Assessment
                                  </a>
                                </td>
                                <td style={{ width: "9%" }}>
                                  {analyticDetailsData?.student_answers_json?.[index]?.file_data?.length > 0 ? ((() => {
                                    const files = analyticDetailsData?.student_answers_json?.[index]?.file_data;

                                    const hasOnlyWebmAudio = files?.length === 1 &&
                                      files[0]?.name?.toLowerCase().endsWith('.webm');
                                    return (
                                      <div className="uploads-section">
                                        <img
                                          src={hasOnlyWebmAudio ? headphones : uploads_svg}
                                          alt={hasOnlyWebmAudio ? "Audio file" : "Uploaded file"}
                                          style={{ opacity: 0.6 }}
                                        />
                                        <div className="uploads-files"> {files.length}{" "}
                                          {hasOnlyWebmAudio
                                            ? files.length === 1 ? "Audio file" : "Audio files"
                                            : files.length === 1 ? "File" : "Files"
                                          }
                                        </div>
                                      </div>
                                    );
                                  })()
                                  ) : (
                                    <div className="no-uploads-dash">-</div>
                                  )}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      ) : (
                        <div style={{ display: "table-caption" }}>
                          <p style={{ textAlign: "center", margin: "20px auto" }}>
                            No Assignment Analytics Found
                          </p>
                        </div>
                      )}
                    </table>
                  </div></>}
              </div>
            </div>
          </div>
          {showRubric && (
            <ShowTextPopup
              title="Rubric"
              data={rubricData?.rubric ?? "No Rubric Found"}
              onClick={toogle}
            />
          )}

          {showDropdown && (
            <div className="AssignmentViewProgress-mock-test-wrapper">
              <div
                className="AssignmentViewProgress-mock-test-container max-h-[90vh] overflow-y-auto"
                data-aos="zoom-in"
              >
                {
                  <QuestionNew
                    assignment={
                      analyticDetailsData?.student_answers_json[assignmentIndex]
                    }
                    ai_evaluation_json={analyticDetailsData?.ai_evaluation_json}
                    index={assignmentIndex}
                    arrayIndex={arrayIndex}
                    currentStep={assignmentIndex + 1}
                    totalSteps={
                      analyticDetailsData?.student_answers_json.length
                    }
                    handleNext={() =>
                      assignmentIndex <
                        analyticDetailsData?.student_answers_json.length - 1
                        ? setAssignmentIndex((p) => p + 1)
                        : null
                    }
                    handleBack={() => setAssignmentIndex((p) => p - 1)}
                    isLast={
                      assignmentIndex ===
                      analyticDetailsData?.student_answers_json.length - 1
                    }
                    isFirst={assignmentIndex === 0}
                    close={
                      <span
                        onClick={toggleDropdown}
                        className="AssignmentViewProgress-mock-test-close-btn"
                      >
                        <i className="fa-solid fa-x"></i>
                      </span>
                    }
                    questions={
                      analyticDetailsData?.ai_evaluation_json?.questions
                    }
                    // assignmentType={analyticDetailsData?.assignment_analytics && analyticDetailsData?.assignment_analytics[0]?.assignment_type}
                    assignmentType={analyticDetailsData?.student_answers_json && analyticDetailsData?.student_answers_json[assignmentIndex].type}
                    courseType={courseType}
                    handleGetTeacherAnswerAssignmentAnalytics={handleGetTeacherAnswerAssignmentAnalytics}
                    analyticDetailsData={analyticDetailsData}
                    setAnalyticDetailsData={setAnalyticDetailsData}
                    is_practice_assignment={is_practice_assignment}
                    myRole={location?.state?.myRole}
                    course_id={course_id}
                    TeacherMyCourse={TeacherMyCourse}
                    currentAssignment={analyticDetailsData?.student_answers_json[assignmentIndex]}
                  />
                }
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AssignmentAnalytics;
